export default "__VITE_ASSET__Bdyk7zBD__"